module.exports = __webpack_public_path__ + "img/zoomed-Data-withwords.1775fa89.png";